import { useState } from 'react'
import type { GenerateWorkoutConstraints } from '../components/cards/GenerateWorkoutConstraintsModal'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../lib/supabase'
import type { Workout } from '../types/database.tables'

export type UseWorkoutGenerationOptions = {}

export const useWorkoutGeneration = (options?: UseWorkoutGenerationOptions) => {
  const [isGenerating, setIsGenerating] = useState(false)
  const { user } = useAuth()

  const generateWorkouts = async (constraints: GenerateWorkoutConstraints): Promise<Omit<Workout, 'id'>[]> => {
    if (!user) {
      throw new Error('User must be authenticated to generate workouts')
    }

    setIsGenerating(true)

    try {
      // Calculate weekly availability from current workouts or defaults
      const weeklyAvailability = {
        mon: 90,
        tue: 90,
        wed: 90,
        thu: 90,
        fri: 90,
        sat: 180,
        sun: 180,
      }

      // Calculate rest days from current workouts (days with no workouts)
      const restDays: string[] = []
      /*
      weekDates.forEach((date, index) => {
        const dateString = formatDateForComparison(date);
        const dayWorkouts = workouts.filter(w => w.date === dateString);
        if (dayWorkouts.length === 0) {
          const dayNames = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
          restDays.push(dayNames[date.getDay()]);
        }
      });
       */

      const requestPayload = {
        state: {
          CTL: null,
          ATL: null,
          TSB: null,
        },
        constraints,
        algorithm: 'LLM',
        /*
        TODO: include
        weeklyAvailability,
        restDays,
        disciplineSplit: {
          swim: constraints.swimSplit || 0.2,
          bike: constraints.bikeSplit || 0.4,
          run: constraints.runSplit || 0.4
        },
        additionalWorkouts: {
          includeStrength: constraints.includeStrength,
          includeMobility: constraints.includeMobility
        },
         */
      }

      const { data, error } = await supabase.functions.invoke('workout-planner', {
        body: requestPayload,
      })

      if (error) {
        throw new Error(`Failed to generate workout plan: ${error.message}`)
      }

      if (!data || !data.days) {
        throw new Error('Invalid response from workout planner')
      }

      // Convert the response to ScheduledWorkout format
      const generatedWorkouts: Omit<Workout, 'id'>[] = []
      data.days.forEach((dayPlan: any) => {
        return dayPlan.workouts.forEach((workout: Workout) => {
          generatedWorkouts.push({
            ...workout,
          })
        })
      })

      console.log('Generated workouts:', generatedWorkouts)
      return generatedWorkouts
    } catch (error: unknown) {
      console.error('Failed to generate workout plan:', error)
      throw new Error(`Failed to generate workout plan: ${(error as any).message}`)
    } finally {
      setIsGenerating(false)
    }
  }

  return {
    generateWorkouts,
    isGenerating,
  }
}
